import { throttle } from 'lodash';
import { db } from '../firebase';

/**
 * Subscribes to votes data with throttled updates.
 * Updates are limited to once every 500ms to prevent UI thrashing
 * while still providing near real-time feedback.
 */
export function subscribeVotes(setVotes) {
    if (!db) return () => { };

    const votesRef = db.ref('votes');

    // Throttle the callback, not the subscription
    const throttledUpdate = throttle((snapshot) => {
        const newVotes = snapshot.val() || {};
        setVotes(newVotes);
    }, 500, { leading: true, trailing: true });

    votesRef.on('value', throttledUpdate);

    return () => {
        throttledUpdate.cancel();
        votesRef.off('value', throttledUpdate);
    };
}
